import React from 'react';
import { Helmet } from "react-helmet";
// import _get from 'lodash/get';
import '../City/EditCity/style.css';
// import EmptyMessage from 'components/EmptyMessage/EmptyMessage';
import Col from 'react-bootstrap/Col';
import Footer from 'components/Footer/Footer';
// import Button from 'components/Button/Button';
// import ChannelImage from 'Assets/city-hero.png';
import ManageBanner from 'components/Banner/ManageBanner';

import { organization_user_access_level, org_friendly_url, apiUrl, myHeaders_With_Cache_Control, user_entity_uuid, user_access_token, user_access_level, user_Status_Ver } from "Api/Api";
// , myHeaders_Auth_With_Cache_Control
import axios from "axios";
// import { origin } from 'utils/Helper';

import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner';
// import presentation from 'Assets/presentation-deck.svg';
// import users from 'Assets/users.svg';
// import eye from 'Assets/eye.svg';
import { withRouter, NavLink } from "react-router-dom";
import { local_routes, feature_names } from 'utils/Routes';
import home from 'Assets/home.svg';
import { Redirect } from 'react-router-dom';
//import ChannelInfo from 'pages/Channels/ChannelInfo/ChannelInfo';
//import Venues from 'pages/Channels/ChannelInfo/ChannelVenue';
//import ChannelEventList from 'pages/Channels/ChannelInfo/ChannelEventList';
import WorkspaceInfo from 'pages/ManageWorkspace/ManageWorkspaceTabs/WorkspaceInfo';
import WorkspaceUsers from 'pages/ManageWorkspace/ManageWorkspaceTabs/WorkspaceUsers';
//import WorkspaceEvents from 'pages/ManageWorkspace/ManageWorkspaceTabs/WorkspaceEventList';
import EventList from 'components/EventListTable/EventList';
import WorkspaceVenues from 'pages/ManageWorkspace/ManageWorkspaceTabs/WorkspaceVenues';
import WorkspacePresentations from 'pages/ManageWorkspace/ManageWorkspaceTabs/WorkspacePresentations';
//import PkList from 'components/PkListTable/PkList';
// import WorkspaceChannels from 'pages/ManageWorkspace/ManageWorkspaceTabs/WorkspaceChannels';
import logo from "Assets/logo.svg";
//let channelUid;
//let friendlyUrl = '';

class ManageWorkspace extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            org_data: {},
            pageLoader: true,
            allowed: true,
            currentTab: "none",
        };

        this.workspace_base_url = "";
        //const { match: { params: { org_friendly_url } = {} } = {} } = this.props;
        if (org_friendly_url) {
          this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
        }
        this.user_data = {};
    }

    componentDidUpdate(prevProps) {
        let { location: { pathname } } = this.props;

        if (prevProps.location.pathname === pathname) return;
        this.routeChanged();
    }

    routeChanged() {
        if (this.props.match.params.otherpage) {
            if (this.props.match.params.otherpage === 'main') {
                this.setState({ currentTab: "main" })
            } else if (this.props.match.params.otherpage === 'users') {
                this.setState({ currentTab: "users" })
            } else if (this.props.match.params.otherpage === 'events') {
                this.setState({ currentTab: "events" })
            } else if (this.props.match.params.otherpage === 'venues') {
                this.setState({ currentTab: "venues" })
            //} else if (this.props.match.params.otherpage === 'teams') {
                //this.setState({ currentTab: "teams" })
            } else if (this.props.match.params.otherpage === 'presentations') {
                this.setState({ currentTab: "presentations" })
            } else {
                // bad tab!
                this.setState({ currentTab: null });
            }
        } else {
            // no tab!
            this.setState({ currentTab: null });
        }
    }

    componentDidMount = async function () {
        window.scrollTo(0, 0);

        if (!user_access_token || user_Status_Ver !== "1") {
            this.setState({ allowed: false });
            return;
        }

        let allowed = false;
        if (user_access_level === "admin") {
            // allowed
            allowed = true;
        }
        if (organization_user_access_level === "admin") {
            // allowed
            allowed = true;
        }
        if (!allowed) {
            console.error("User not allowed to manage workspace");
            this.setState({ allowed: false });
            return;
        }

        try {
            let [org_data_response,user_data_response,user_location_data_response] = await Promise.all([
                axios.get(`${apiUrl}organizations/${org_friendly_url}`, myHeaders_With_Cache_Control),
                axios.get(`${apiUrl}users/${user_entity_uuid}`, myHeaders_With_Cache_Control),
                axios.get(`${apiUrl}users/${user_entity_uuid}/locations.audience?filter_obj=${encodeURIComponent('{"resident_integer":{"gte":1}}')}`, myHeaders_With_Cache_Control),
                //axios.get(`${apiUrl}organizations/${org_friendly_url}/channels`, myHeaders_With_Cache_Control),
            ]);
            this.user_data = user_data_response.data;
            this.user_data.locations = user_location_data_response.data;
            //org_data_response.data.channels = channels_data_response.data;
            
            this.setState({ org_data:org_data_response.data, pageLoader: false});
        } catch (err) {
            this.setState({ pageLoader: false });
            return;
        }
        
        this.routeChanged();
    }

    bannerRender = () => {
        let logo_url;
        if (this.state.org_data.banner_image_url) {
            logo_url = this.state.org_data.banner_image_url;
        } else if (this.state.org_data.image_url) {
            logo_url = this.state.org_data.image_url;
        }
        
        if (logo_url) {
            let array = logo_url.split("/");
            logo_url=`${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/1600x400/${array[5]}`;
        } else {
            logo_url = logo; // default
        }
        return (
            <div>
                <div style={{height:'222px',textAlign:'center'}} className="eventImage city-chicago">
                    <img src={logo_url} style={{width:'50%'}} className="city-img" alt="img" />
                    <div className="container contentPosition">
                        <div className="city-name">
                            <h1 className="cityName">{this.state.org_data.entity_name}</h1>
                        </div>
                    </div>
                </div>
            </div>
        );        
    }

    /*
    // Banner section Start
    bannerApiImage = () => {
        const { channel_name, eventImg, OrganizerArr } = this.state;
        const { match } = this.props;
        const friendlyUrl = _get(match, 'params.friendly_url', '');
        let url = eventImg;
        let array = url.split("/");
        let bannerImageUrl = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/padblack_900x360/${array[5]}`;
        return (
            <div>
                <div className="eventImage city-chicago">
                    <img src={bannerImageUrl} className="city-img" alt="img" />
                    <div className="container contentPosition">
                        <div className="city-name">
                            <h1 className="cityName">{channel_name !== undefined && !null && channel_name}</h1>
                        </div>
                        {OrganizerArr > 0 ?
                            <div className="citySignUp">
                                <h4>This Channel is Open - Sign Up</h4>
                                <p>If you think you have what is takes to run PechKucha Nights in your channel, apply to become
                                  the official organizer! Join the celebration of creativity by becoming part of our global network of volunteers
                                  and put your channel's creative talent and hidden heroes on the world stage!</p>
                                <Button theme="btn-global btn-green Form_Btn_Pad font-normal marTop5" OnClickMet={this.OnClickClaimBtn}>
                                    Claim Channel
                                </Button>
                            </div>
                            : null
                        }
                        <NavLink to={`${this.workspace_base_url}${local_routes.channels}/${friendlyUrl}`}>
                            <Button theme="btn-global btn-green Form_Btn_Pad font-normal marTop5 back-cityBtn">
                                Back to Channel
                            </Button>
                        </NavLink>
                    </div>
                </div>
            </div>
        );
    }
    */
    
    /*
    bannerApiImageEmpty = () => {
        const { channel_name } = this.state;
        const { match } = this.props;
        const friendlyUrl = _get(match, 'params.friendly_url', '');
        return (
            <div>
                <div className="bannerEventImage city-chicago">
                    <img src={ChannelImage} className="city-img" alt="img" />
                    <div className="container contentPosition">
                        <h1 className="cityName">{channel_name}</h1>
                        <NavLink
                            to={`${this.workspace_base_url}${local_routes.channels}/${friendlyUrl}`}
                        >
                            <Button theme="btn-global Form_Btn_Pad font-normal marTop5 back-cityBtn">
                                Back to Channel
                            </Button>
                        </NavLink>
                    </div>
                </div>
            </div>
        );
    }
    // Banner section End
    */
    
    render() {
        //const { match: { params: { friendly_url } = {} } = {} } = this.props;
        const { currentTab, allowed, pageLoader, org_image_url } = this.state;

        if (!allowed) {
            return (
                <Redirect to="/404" />
            )
        }

        if (!currentTab) {
            return (
                <Redirect to={`${this.workspace_base_url}${local_routes.manageworkspace}/main`} />
            )
        }

        if (pageLoader) {
            return (
                <FullPageSpinner />
            )
        }
        
        let carousel_images = [];
        if (this.state.org_data.banner_image_url) {
            carousel_images.push(this.state.org_data.banner_image_url);
        } else if (this.state.org_data.image_url) {
            carousel_images.push(this.state.org_data.image_url);
        }
        
        return (
            <React.Fragment>
                <Helmet>
                    <title>Manage PechaKucha {feature_names.Workspace}</title>
                    <meta name="robots" content="noindex" />
                </Helmet>
                <React.Fragment>
                    <div className="main-section editCityData">
                        {/* Banner section starts */}
                        
                <ManageBanner
                  entity_name={this.state.org_data.entity_name}
                  carousel_images={carousel_images}
                  back_link={this.workspace_base_url}
                />
                        {/*
                        <div>
                            {this.bannerRender()}
                        </div>
                        */}
                        {/* Banner section Ends */}
                        <div className="editCityBg">
                            <div className="container editCityMenu">
                                <Col lg={12} className="pad-mb0 pad0">
                                    <div>
                                        <div className="sub-menu-nav" style={{borderBottom: "medium none"}}>
                                            <ul>
                                                <li><NavLink activeStyle={{ color: "#D12F50" }} to={`${this.workspace_base_url}${local_routes.manageworkspace}/main`}>INFO</NavLink></li>
                                                <li><NavLink activeStyle={{ color: "#D12F50" }} to={`${this.workspace_base_url}${local_routes.manageworkspace}/users`}>USERS</NavLink></li>
                                                <li><NavLink activeStyle={{ color: "#D12F50" }} to={`${this.workspace_base_url}${local_routes.manageworkspace}/events`}>EVENTS</NavLink></li>
                                                <li><NavLink activeStyle={{ color: "#D12F50" }} to={`${this.workspace_base_url}${local_routes.manageworkspace}/venues`}>VENUES</NavLink></li>
                                                <li><NavLink activeStyle={{ color: "#D12F50" }} to={`${this.workspace_base_url}${local_routes.manageworkspace}/presentations`}>PRESENTATIONS</NavLink></li>
                                                {/*
                                                { this.state.org_data.account_level === 'premium' &&
                                                    <li><NavLink activeStyle={{ color: "#D12F50" }} to={`${this.workspace_base_url}${local_routes.manageworkspace}/teams`}>TEAMS</NavLink></li>
                                                }
                                                */}
                                            </ul>
                                        </div>
                                        {this.state.currentTab === 'main' &&
                                            <WorkspaceInfo user_data={this.user_data} org_data={this.state.org_data} {...this.props} />
                                        }
                                        {this.state.currentTab === 'users' &&
                                            <WorkspaceUsers user_data={this.user_data} org_data={this.state.org_data} {...this.props} />
                                        }
                                        {this.state.currentTab === 'events' &&
                                            <EventList
                                                source_info={{...this.state.org_data,entity_type:'organizations'}}
                                                referrer={`${this.workspace_base_url}${local_routes.manageworkspace}/events`}
                                            />
                                        }
                                        {this.state.currentTab === 'venues' &&
                                            <WorkspaceVenues user_data={this.user_data} org_data={this.state.org_data} {...this.props} />
                                        }
                                        {this.state.currentTab === 'presentations' &&
                                            //<PkList
                                            //    source_info={{...this.state.org_data,entity_type:'organizations'}}
                                            //    referrer={`${this.workspace_base_url}${local_routes.manageworkspace}/presentations`}
                                            ///>
                                            <WorkspacePresentations user_data={this.user_data} org_data={this.state.org_data} {...this.props} />
                                        }
                                        {/*
                                        {this.state.currentTab === 'teams' &&
                                            <WorkspaceChannels user_data={this.user_data} org_data={this.state.org_data} {...this.props} />
                                        }
                                        */}
                                    </div>
                                </Col>
                            </div>
                        </div>
                        {/* Banner sub navigation starts */}
                        {/* Banner sub navigation ends */}
                        <Footer
                            homeImg={home}
                            homeImgRef="/"
                            breadcrumbSubPage={`Manage ${feature_names.Workspace}`}
                            mainPageLink={this.workspace_base_url}
                        />
                    </div>
                </React.Fragment>
            </React.Fragment>
        )
    }
}

export default withRouter(ManageWorkspace);

